import React, { useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import { gql } from 'apollo-boost'
import { Query } from 'react-apollo'
import { Client } from '../../apollo/client'
import Spinner from '../utils/spinner'
import isEmpty from 'lodash.isempty'
import useCart from '../../hooks/useCart'
import useTheme from '../../hooks/theme'
import { onAddToCart, onProductClick } from '../utils/analytics'
import getCurrency from '../utils/currency'
import { getZaBuyLink } from '../utils/zaProductLinks'

import {
	TopModelsSection,
	TopModelsContainer,
	ItemsContainer,
	ItemContainer,
	ItemInnerContainer,
	ItemImageContainer,
	TopModelItemImage,
	DetailsContainer,
	ProductName,
	AddToCartContainer,
	Price,
	TopModelFeature,
	ItemDetails,
	Continue,
	NullText,
	Button,
	ViewAll,
	ViewMore,
} from './styles'
import Dolphin from '../svg/dolphin'

const TopModels = ({ modelimages, locale, checkedLocale }) => {
	const getCountry = locale.split('-')[1].toLowerCase()
	const { addToCart } = useCart()
	const { openCart } = useTheme()
	const isBrowser = typeof window !== 'undefined'
	const [items, setItems] = useState([])
	useEffect(() => {
		/**
		 * Google Analytics - Tag Manager - Enhanced Ecommerce
		 * Measuring product impressions for every search result change
		 * */
		const floatPrice = price =>
			price >= 1 ? parseFloat(price).toFixed(2) : parseFloat(0).toFixed(2)
		let impressions =
			items.length >= 1 &&
			items.map((item, index) => {
				return {
					name: item.seoTitle, // the name of the product, including Title and Subtitle
					id: item.sku, // product serial number
					price: Number(floatPrice(item.price)), // actual price per unit or in case of fixed price discounts the discounted price
					brand: item.brand, // product brand
					category: [item.categories && item.categories.title].toString(), // Dolphin domestic, Dolphin commercial, mineral swim, ozone swim
					list: 'Category List', // the type of list for the current product impression )e.g. Category List, Search Results etc.)
					position: index + 1, // the position of the product within the list
				}
			})
		if (isBrowser && window.dataLayer && items.length >= 1) {
			window.dataLayer.push({
				event: 'productImpression',
				ecommerce: {
					currencyCode: 'AUD',
					impressions,
				},
			})
		}
	}, [items])

	const currency = getCurrency(locale)
	return (
		<TopModelsSection>
			<TopModelsContainer>
				<ItemsContainer>
					<Query query={locale != 'en-ZA' ? APOLLO_DOLPHIN_QUERY : APOLLO_DOLPHIN_QUERY_ZA} client={Client} variables={{ locale }}>
						{({ data, loading, error }) => {
							if (loading) {
								return <Spinner />
							}
							if (error) {
								return (
									<NullText>Something is wrong. Please Try Again!</NullText>
								)
							}
							const {
								productCollection: { items },
							} = data
							setItems(items)

							return items.length > 0 ? (
								items.map((item, i) => {
									if (!isEmpty(item)) {
										let title = item.seoTitle
										let titleSplit = title.split(' ')
										let dolphin = titleSplit.find(ttl => ttl === 'Dolphin')

										let itemName = item.seoTitle.split('Dolphin').slice(1)

										const filterImg = img => {
											return img.filter(x => {
												return x.node.slug === item.slug ? x : ''
											})
										}

										const filteredByslug = filterImg(modelimages)

										return (
											<ItemContainer key={i}>
												<ItemInnerContainer>
													<ItemImageContainer
														onClick={() => {
															onProductClick(
																{
																	name: item.seoTitle,
																	sku: item.sku,
																	price: Number(item.price * 100),
																	brand: item.brand,
																	categories: item.categories,
																	list: 'Category List',
																	position: i + 1,
																},
																'Category List',
																i,
																navigate(`${checkedLocale}/product/${item.slug}`)
															)
														}}
													>
														<TopModelItemImage>
															<source
																srcSet={
																	filteredByslug[0].node.images[0].fluid.srcWebp
																}
																type="image/webp"
															/>
															<source
																srcSet={
																	filteredByslug[0].node.images[0].fluid.src
																}
															/>
															<img
																src={filteredByslug[0].node.images[0].fluid.src}
																alt={
																	filteredByslug[0].node.images[0].description
																}
															/>
														</TopModelItemImage>
													</ItemImageContainer>
													<DetailsContainer>
														<ProductName>
															<span>{dolphin}</span>
															{itemName}
														</ProductName>
														<Price>
															{item.price.toLocaleString(locale , {
																style: 'currency',
																currency: currency,
															})}
														</Price>
														{item.featuresCollection.items.map((feature, i) => {
															return (
																<TopModelFeature key={`${feature.title}${i}`}>
																	{feature.title}
																</TopModelFeature>
															)
														})}
													</DetailsContainer>
													<AddToCartContainer>
														{
															locale === 'en-ZA' ? (
															<Button
																onClick={() => {
																window.location.href = getZaBuyLink(item.slug)
																}}
															>
																Buy Now
															</Button>
															) : locale === 'en-AU' ? (
																item.active === null || item.active === true ? (
																	<Button
																		onClick={() => {
																			addToCart({
																				img:
																					filteredByslug[0].node.images[0].fluid.src,
																				slug: item.slug,
																				name: item.seoTitle,
																				sku: item.sku,
																				price: Number(item.price * 100),
																				brand: item.brand,
																				category: [
																					item.categories && item.categories.title,
																				].toString(),
																				shippingClass: item.shippingClass,
																				quantity: 1,
																			})
																			onAddToCart(
																				{
																					name: item.seoTitle,
																					sku: item.sku,
																					price: Number(item.price * 100),
																					brand: item.brand,
																					category: [
																						item.categories && item.categories.title,
																					].toString(),
																					shippingClass: item.shippingClass,
																					list: 'Category List',
																					position: i + 1,
																					quantity: 1,
																				},
																				'Category List'
																			)
																			openCart()
																		}}
																	>
																		Add to cart
																	</Button>
																) : (
																	<Button onClick={() => { navigate(`${checkedLocale}/support/contact/?subject=${encodeURIComponent(
																		item.seoTitle.toLowerCase()
																	)}#contact-form`)}}>
																		Enquire now
																	</Button>
																)
															) : (
																<Button onClick={() => { navigate(`https://mydolphin.co.${getCountry}`)}}>
																	Buy at mydolphin
																</Button>
															)
														}
													</AddToCartContainer>
													<ItemDetails
														onClick={() => {
															onProductClick(
																{
																	name: item.seoTitle,
																	sku: item.sku,
																	price: Number(item.price * 100),
																	brand: item.brand,
																	categories: item.categories,
																	list: 'Category List',
																	position: i + 1,
																},
																'Category List',
																i,
																navigate(`${checkedLocale}/product/${item.slug}`)
															)
														}}
													>
														<Continue>View Product</Continue>
													</ItemDetails>
												</ItemInnerContainer>
											</ItemContainer>
										)
									}
								})
							) : (
								<NullText>No items can be found!</NullText>
							)
						}}
					</Query>
				</ItemsContainer>
				<ViewMore>
					{
						locale === 'en-AU' ? (
							<ViewAll to={`${checkedLocale}/shop/?brand=Dolphin`}>View All Models</ViewAll>
						) : (
							<ViewAll to={`https://mydolphin.co.${getCountry}/pool-cleaners/`}>View All Models</ViewAll>
						)
					}
				</ViewMore>
			</TopModelsContainer>
		</TopModelsSection>
	)
}

const APOLLO_DOLPHIN_QUERY = gql`
	query topModelsQuery($locale: String!) {
		productCollection(where: { sys: { id_in: ["hhI3zkSAi4SO72xjy7FiS", "6LVEjM0aLN7QtwVo7OYhki"]} },locale: $locale  , order: [price_DESC]) {
			items {
				seoTitle
				seoDescription
				slug
				sku
				price
				model
				brand
				active
				series
				categories {
					title: seoTitle
					slug
				}
				shippingClass
				featuresCollection(limit: 3) {
					items {
						title
					}
				}
			}
		}
	}
`
const APOLLO_DOLPHIN_QUERY_ZA = gql`
	query topModelsQuery($locale: String!) {
		productCollection(where: { sys: { id_in: ["1T2Jd2wY1BNeFoctpLRPC9", "4PDWDCd3bd7fOAaQ6i8WCE"]} },locale: $locale  , order: [price_DESC]) {
			items {
				seoTitle
				seoDescription
				slug
				sku
				price
				model
				brand
				active
				series
				categories {
					title: seoTitle
					slug
				}
				shippingClass
				featuresCollection(limit: 3) {
					items {
						title
					}
				}
			}
		}
	}
`

export default TopModels
